// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__Sm3dY","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__cKm3P"};